<template>
<md-card-content class="ql-cue-body" v-bind:style="style()" :key="handler">
    <form novalidate @submit.stop.prevent="keyPress" @keyup.stop.prevent="keyPress" v-if="localCue.data">
        <div class="flex-row">
            <md-input-container class="field-label">
                <label for="label">Label</label>
                <md-input v-model="localCue.data.label" @blur="modifyCue('data.label', localCue.data.label)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-button class="md-icon-button" v-if="!locked && !editing && editable" @click="destroy">
                <md-icon>delete</md-icon>
                <md-tooltip>Delete Cue</md-tooltip>
            </md-button>
        </div>
        <div class="flex-row">
            <md-input-container class="field-description" v-if="isAvailable('description')">
                <label for="description">Description</label>
                <md-input v-model="localCue.data.description" @blur="modifyCue('data.description', localCue.data.description)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-parts" v-if="isAvailable('parts')">
                <label for="parts">Parts</label>
                <md-select v-model="localCue.data.parts" @change="partsChanged" :disabled="!editable">
                    <md-option v-for="(part, index) in ['', 2,3,4,5,6,7,8]" :value="part" :key="index">{{part}}</md-option>
                </md-select>
            </md-input-container>
        </div>
        <div class="flex-row flex-column" v-if="localCue.data.parts">
            <div class="field-parts-data flex-row flex-column" v-for="partData in localCue.data.partsData">
                <div class="flex-row">
                    <md-input-container class="field-part">
                        <label for="part">P</label>
                        <md-input v-model="localCue.data.partsData[getPartIndex(partData)].id" @blur="modifyCue(`data.partsData[${getPartIndex(partData)}].id`, localCue.data.partsData[getPartIndex(partData)].id)" :readonly="!editable"></md-input>
                    </md-input-container>
                    <md-input-container class="field-part-label" v-if="isAvailable('label')">
                        <label for="label">Label</label>
                        <md-input v-model="localCue.data.partsData[getPartIndex(partData)].label" @blur="modifyCue(`data.partsData[${getPartIndex(partData)}].label`, localCue.data.partsData[getPartIndex(partData)].label)" :readonly="!editable"></md-input>
                    </md-input-container>
                </div>
                <div class="flex-row">
                    <md-input-container class="field-time" v-if="isAvailable('time')">
                        <label for="time">Time</label>
                        <md-input v-model="localCue.data.partsData[getPartIndex(partData)].time" @blur="modifyCue(`localCue.data.partsData[${getPartIndex(partData)}].time`, localCue.data.partsData[getPartIndex(partData)].time)" :readonly="!editable"></md-input>
                    </md-input-container>
                    <md-input-container class="field-focus" v-if="isAvailable('focus')">
                        <label for="focus">Focus</label>
                        <md-input v-model="localCue.data.partsData[getPartIndex(partData)].focus" @blur="modifyCue(`localCue.data.partsData[${getPartIndex(partData)}].focus`, localCue.data.partsData[getPartIndex(partData)].focus)" :readonly="!editable"></md-input>
                    </md-input-container>
                    <md-input-container class="field-color" v-if="isAvailable('color')">
                        <label for="color">Color</label>
                        <md-input v-model="localCue.data.partsData[getPartIndex(partData)].color" @blur="modifyCue(`localCue.data.partsData[${getPartIndex(partData)}].color`, localCue.data.partsData[getPartIndex(partData)].color)" :readonly="!editable"></md-input>
                    </md-input-container>
                    <md-input-container class="field-beam" v-if="isAvailable('beam')">
                        <label for="beam">Beam</label>
                        <md-input v-model="localCue.data.partsData[getPartIndex(partData)].beam" @blur="modifyCue(`localCue.data.partsData[${getPartIndex(partData)}].beam`, localCue.data.partsData[getPartIndex(partData)].beam)" :readonly="!editable"></md-input>
                    </md-input-container>
                    <md-input-container class="field-mark" v-if="isAvailable('mark')">
                        <label for="mark">M</label>
                        <md-select v-model="localCue.data.partsData[getPartIndex(partData)].mark" @change="updateCue" :disabled="!editable">
                            <md-option v-for="(mark, index) in ['', 'M', 'D', 'R', '+', 'x']" :value="mark" :key="index">{{mark}}</md-option>
                        </md-select>
                    </md-input-container>
                </div>
            </div>
        </div>
        <div class="flex-row" v-else>
            <md-input-container class="field-time" v-if="isAvailable('time')">
                <label for="time">Time</label>
                <md-input v-model="localCue.data.time" @blur="modifyCue('data.time', localCue.data.time)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-focus" v-if="isAvailable('focus')">
                <label for="focus">Focus</label>
                <md-input v-model="localCue.data.focus" @blur="modifyCue('data.focus', localCue.data.focus)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-color" v-if="isAvailable('color')">
                <label for="color">Color</label>
                <md-input v-model="localCue.data.color" @blur="modifyCue('data.color', localCue.data.color)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-beam" v-if="isAvailable('beam')">
                <label for="beam">Beam</label>
                <md-input v-model="localCue.data.beam" @blur="modifyCue('data.beam', localCue.data.beam)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-mark" v-if="isAvailable('mark')">
                <label for="mark">M</label>
                <md-select v-model="localCue.data.mark" @change="updateCue" :disabled="!editable">
                    <md-option v-for="(mark, index) in ['', 'M', 'D', 'R', '+', 'x']" :value="mark" :key="index">{{mark}}</md-option>
                </md-select>
            </md-input-container>
        </div>
        <div class="flex-row">
            <md-input-container class="field-duration" v-if="isAvailable('duration')">
                <label for="duration">Duration</label>
                <md-input v-model="localCue.data.duration" @blur="modifyCue('data.duration', localCue.data.duration)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-follow-hang-type" v-if="isAvailable('followHang')">
                <label for="follow-hang-type">F/H</label>
                <select class="custom-select" v-model="localCue.data.followHangType" @change="updateCue" :disabled="!editable">
                    <option v-for="(fh, index) in ['', 'F', 'H']" :value="fh" :key="index">{{fh}}</option>
                </select>
            </md-input-container>
            <md-input-container class="field-follow-hang" v-if="isAvailable('followHang')">
                <label for="follow-hang">Fw/Hg</label>
                <md-input v-model="localCue.data.followHang" @blur="modifyCue('data.followHang', localCue.data.followHang)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-block" v-if="isAvailable('block')">
                <label for="block">Block</label>
                <md-select v-model="localCue.data.block" @change="updateCue" :disabled="!editable">
                    <md-option v-for="(block, index) in ['', 'B', 'I', 'b']" :value="block" :key="index">{{block}}</md-option>
                </md-select>
            </md-input-container>
            <md-input-container class="field-assert" v-if="isAvailable('assert')">
                <label for="assert">Assert</label>
                <md-select v-model="localCue.data.assert" @change="updateCue" :disabled="!editable">
                    <md-option v-for="(assert, index) in ['', 'A', 'a']" :value="assert" :key="index">{{assert}}</md-option>
                </md-select>
            </md-input-container>
        </div>
        <div class="flex-row">
            <md-input-container class="field-link" v-if="isAvailable('link')">
                <label for="link">Link</label>
                <md-input v-model="localCue.data.link" @blur="modifyCue('data.link', localCue.data.link)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-loop" v-if="isAvailable('loop')">
                <label for="loop">Loop</label>
                <md-input v-model="localCue.data.loop" @blur="modifyCue('data.loop', localCue.data.loop)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-curve" v-if="isAvailable('curve')">
                <label for="curve">Curve</label>
                <md-input v-model="localCue.data.curve" @blur="modifyCue('data.curve', localCue.data.curve)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-external-links" v-if="isAvailable('externalLinks')">
                <label for="external-links">Ext Links</label>
                <md-input v-model="localCue.data.externalLinks" @blur="modifyCue('data.externalLinks', localCue.data.externalLinks)" :readonly="!editable"></md-input>
            </md-input-container>
        </div>
        <div class="flex-row">
            <md-input-container class="field-notes" v-if="isAvailable('notes')">
                <label for="notes">Notes</label>
                <md-input v-model="localCue.data.notes" @blur="modifyCue('data.notes', localCue.data.notes)" :readonly="!editable"></md-input>
            </md-input-container>
        </div>
        <div class="flex-row">
            <md-input-container class="field-target" v-if="isAvailable('target')">
                <label for="target">Target</label>
                <md-input v-model="localCue.data.target" @blur="modifyCue('data.target', localCue.data.target)" :readonly="!editable"></md-input>
            </md-input-container>
        </div>
        <div class="flex-row">
            <md-input-container class="field-preWait" v-if="isAvailable('preWait')">
                <label for="pre-wait">Pre Wait</label>
                <md-input v-model="localCue.data.preWait" @blur="modifyCue('data.preWait', localCue.data.preWait)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-action" v-if="isAvailable('action')">
                <label for="action">Action</label>
                <md-input v-model="localCue.data.action" @blur="modifyCue('data.action', localCue.data.action)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-postWait" v-if="isAvailable('postWait')">
                <label for="post-wait">Post Wait</label>
                <md-input v-model="localCue.data.postWait" @blur="modifyCue('data.postWait', localCue.data.postWait)" :readonly="!editable"></md-input>
            </md-input-container>
        </div>
        <div class="flex-row">
            <md-input-container class="field-placement" v-if="isAvailable('placement')">
                <label for="placement">Placement</label>
                <md-input v-model="localCue.data.placement" @blur="modifyCue('data.placement', localCue.data.placement)" :readonly="!editable"></md-input>
            </md-input-container>
        </div>
        <div class="flex-row">
            <md-input-container class="field-purpose" v-if="isAvailable('purpose')">
                <label for="purpose">Purpose</label>
                <md-input v-model="localCue.data.purpose" @blur="modifyCue('data.purpose', localCue.data.purpose)" :readonly="!editable"></md-input>
            </md-input-container>
        </div>
        <div class="flex-row">
            <md-input-container class="field-followMode" v-if="isAvailable('followMode')">
                <label for="follow-mode">Follow Mode</label>
                <md-input v-model="localCue.data.followMode" @blur="modifyCue('data.followMode', localCue.data.followMode)" :readonly="!editable"></md-input>
            </md-input-container>
            <md-input-container class="field-routing" v-if="isAvailable('routing')">
                <label for="routing">Routing</label>
                <md-input v-model="localCue.data.routing" @blur="modifyCue('data.routing', localCue.data.routing)" :readonly="!editable"></md-input>
            </md-input-container>
        </div>
        <div class="flex-row">
            <md-input-container class="field-trigger" v-if="isAvailable('trigger')">
                <label for="trigger">Trigger</label>
                <md-input v-model="localCue.data.trigger" @blur="modifyCue('data.trigger', localCue.data.trigger)" :readonly="!editable"></md-input>
            </md-input-container>
        </div>
        <div class="flex-row">
            <md-input-container class="field-label">
                <label for="work-note">Work Note</label>
                <md-input v-model="localCue.data.workNote" @blur="modifyCue('data.workNote', localCue.data.workNote)" :readonly="!editable"></md-input>
                <md-button class="md-icon-button md-dense btn-mark-workNote" :class="{'workNote-marked': !!localCue.data.workNote}" @click="toggleWorkNote">
                    <md-icon v-show="!localCue.data.workNote">check_box_outline_blank</md-icon>
                    <md-icon v-show="localCue.data.workNote">check_box</md-icon>
                </md-button>
            </md-input-container>
        </div>
        <div class="">
            <md-button class="md-dense btn-close-button" @click="toggle">Close</md-button>
        </div>
    </form>
</md-card-content>
</template>

<script>
import { mapGetters } from 'vuex';
/**
 * Component For...
 */
const ProjectCuesCueBody = {
    name: 'projectCuesCueBody',
    props: [
        'cue',
        'locked',
        'editable',
        'color',
        'selectedScale',
        'isFloatingCue'
    ],
    computed: {
        ...mapGetters([
            'layerByCue'
        ]),
        layer() {
            return this.layerByCue(this.cue);
        },
        availableAttrs() {
            return Object.keys(this.layer.attributes || {}).filter(attr => this.layer.attributes[attr]);
        }
    },
    data: function() {
        return {
            editing: false,
            oldVal: this.$props.cue.description,
            localCue: this.$props.cue,
            updateCueTimerId: null,
            handler: 0
        };
    },
    watch: {
        cue: {
            handler: function() {
                this.localCue = this.cue;
            },
            deep: true
        }
        // No save when the work note becomes '' here: every control that clears it saves
        // the cue itself. The watcher that did also fired for a clear made ELSEWHERE (a
        // collaborator, the 20 Oct repair), so every viewer saved the cue again and the
        // show was stamped edited ("opening = edited", Josh, 20 Oct 2026).
    },
    methods: {
        edit() {
            this.editing = true;
        },
        done() {
            this.editing = false;
            this.oldVal = this.cue.description;
            this.$emit('cueUpdated', this.cue);
        },
        cancel() {
            this.editing = false;
            this.cue.description = this.oldVal;
        },
        keyPress(e) {
            if (e.keyCode === 13) {
                e.target.blur();
            }
        },
        destroy() {
            this.$emit('destroy');
        },
        makeCueFixed() {
            this.$emit('toggle');
            this.$store.dispatch('removeCueFloating', {
                id: this.cue.id
            });
        },
        isAvailable(target) {
            return this.availableAttrs.includes(target);
        },
        partsChanged() {
            if (!this.localCue.data.partsData) {
                this.localCue.data.partsData = [{
                    id: 1,
                    label: '',
                    time: this.localCue.data.time,
                    focus: this.localCue.data.focus,
                    color: this.localCue.data.color,
                    beam: this.localCue.data.beam,
                    mark: this.localCue.data.mark
                }];
            }
            if (this.localCue.data.parts) {
                const cnt = (this.localCue.data.partsData && this.localCue.data.partsData.length) || 0;
                if (cnt > this.localCue.data.parts) {
                    this.localCue.data.partsData.splice(this.localCue.data.parts);
                } else if (cnt < this.localCue.data.parts) {
                    this.localCue.data.partsData = this.localCue.data.partsData.concat(new Array(this.localCue.data.parts - cnt).fill({
                        label: '',
                        time: '',
                        focus: '',
                        color: '',
                        beam: '',
                        mark: ''
                    }).map((partData, index) => ({...partData, id: index + cnt + 1})));
                }
            } else {
                if (this.localCue.data.partsData.length) {
                    this.localCue.data.time = this.localCue.data.partsData['0'].time;
                    this.localCue.data.focus = this.localCue.data.partsData['0'].focus;
                    this.localCue.data.color = this.localCue.data.partsData['0'].color;
                    this.localCue.data.beam = this.localCue.data.partsData['0'].beam;
                    this.localCue.data.mark = this.localCue.data.partsData['0'].mark;
                }
                this.localCue.data.partsData = null;
            }
            this.updateCue();
        },
        getPartIndex(target) {
            return this.localCue.data.partsData.findIndex(partData => partData.id === target.id);
        },
        updateCue() {
            if (this.updateCueTimerId) {
                clearTimeout(this.updateCueTimerId);
            }
            const updatingCue = {...this.localCue};
            this.updateCueTimerId = setTimeout(() => {
                this.$emit('cueUpdated', updatingCue);
            }, 100);
        },
        modifyCue(key) {
            if (this.updateCueTimerId) {
                clearTimeout(this.updateCueTimerId);
            }
            this.updateCueTimerId = setTimeout(() => {
                const value = window.objectPath.get(this.localCue, key);
                this.$store.dispatch('modifyCue', {
                    id: this.cue.id,
                    data: {
                        [key]: value
                    }
                });
            }, 10);
        },
        toggleWorkNote() {
            if (!this.editable) return;
            this.localCue.data.workNote = this.localCue.data.workNote ? '' : ' ';
            this.updateCue();
        },
        toggle() {
            this.$emit('toggle');
        },
        style() {
            return 'border-top: 1px solid ' + this.color + ';';
        }
    }
};

export default ProjectCuesCueBody;
</script>

<style lang="scss">
.app-print-mode {
    .md-card-content {
        height: auto;
    }
    .ql-cue-body {
        box-sizing: border-box;
        padding: 12px 12px 0 !important;
        .md-button {
            float: right;
        }

        .btn-close-button {
            margin: 2px 0 6px;
            padding: 0 8px;
            min-width: 0;
            color: #5ecfdf;
            font-weight: 700;
        }

        .cue-description {
            white-space: pre-line;
        }

        .flex-row {
            display: flex;
            align-items: center;
            & > .md-input-container {
                margin-right: 4px;
                &:last-child {
                    margin-right: 0;
                }
            }
        }
        .flex-wrap {
            flex-wrap: wrap;
        }
        .flex-column {
            flex-direction: column;
            .flex-row {
                width: 100%;
            }
        }

        .md-select {
            min-width: 20px;
            text-align: center;
            .md-select-value {
                padding-right: 0;
            }
            &:after {
                display: none;
            }
        }

        .md-input-container {
            border: solid 1px #bbb;
            border-radius: 5px;
            padding: 4px 8px;
            min-height: 16px;
            margin: 4px 0;
            label {
                color: #aaa;
                top: 50%;
                transform: translateY(-50%);
                left: 1em;
                line-height: 1;
                font-size: 14px;
                white-space: nowrap;
            }
            .md-input {
                font-size: 12px;
            }
            .md-select {
                height: 16px;
                .md-menu {
                    height: 16px;
                }
                .md-select-value {
                    font-size: 12px;
                    height: 16px;
                    line-height: 16px;
                }
            }
            &.md-has-value, &.md-input-focused {
                label {
                    transform: translateY(-20px);
                    padding: 2px 0;
                    background: #fff;
                    color: #00838f;
                    font-size: 11px;
                    &:after {
                        content: '';
                        display: block;
                        position: absolute;
                        width: 120%;
                        height: 100%;
                        left: -10%;
                        top: 0;
                        background: #fff;
                        z-index: -1;
                    }
                }
                textarea.md-input {
                    min-height: 110px;
                    max-height: 110px;
                }
            }
            input, textarea {
                height: 16px;
                line-height: 16px;
            }
            &:after {
                display: none;
            }
            &:not(.field-description):not(.field-notes):not(.field-label):not(.field-part-label) {
                label {
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
                .md-input {
                    text-align: center;
                }
                &.md-has-value, &.md-input-focused {
                    label {
                        transform: translate(-50%, -20px);
                    }
                }
            }
        }

        .field-parts {
            width: 70px;
            margin-left: 8px;
        }
        .field-parts-data {
            width: 100%;
            label {
                font-size: 12px;
            }
        }
        .field-part {
            flex: 0 0 40px;
            .md-input {
                text-align: center;
            }
        }
        .field-mark {
            width: 40px;
        }
        .field-duration {
            flex: 1 0 40%;
        }
        .field-follow-hang {
            flex: 1 0 30%;
        }
        .field-link {
            flex: 1 0 38%;
        }
        .field-external-links {
            flex: 1 0 22%;
        }

        .field-preWait, .field-postWait {
            flex: 1 0 27%;
            label {
                white-space: nowrap;
            }
        }

        .field-followMode {
            flex: 1 0 30%;
            label {
                white-space: nowrap;
            }
        }

        .field-block, .field-assert, .field-external-links {
            label {
                font-size: 12px;
            }
        }

        .field-time, .field-focus, .field-color, .field-beam {
            .md-input {
                font-size: 12px;
            }
        }

        .field-label, .field-description, .field-notes {
            .md-input {
                font-size: 12px;
            }
        }

        .btn-mark-workNote {
            margin: 0;
            width: 16px !important;
            height: 16px !important;
            padding: 0 !important;
            min-width: 0 !important;
            min-height: 0 !important;
            line-height: 16px !important;
            i {
                margin: auto !important;
                color: rgba(0, 0, 0, 0.54) !important;
                width: 16px;
                min-width: 16px;
                height: 16px;
                min-height: 16px;
                font-size: 16px;
            }
            &.workNote-marked {
                i {
                    color: #5ecfdf !important;
                }
            }
        }
    }
}
.md-theme-show-mode {
    .app-print-mode {
        .ql-cue-body {
            .md-input-container {
                &.md-has-value, &.md-input-focused {
                    label {
                        background: #424242;
                        color: #5ecfdf !important;
                        &:after {
                            background: #424242;
                        }
                    }
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// cue-body.vue?5e326c17